'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createClient;

var _redux = require('redux');

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _middlewares = require('./middlewares');

var _middlewares2 = _interopRequireDefault(_middlewares);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APICall = _middlewares2.default.APICall,
    WebSocket = _middlewares2.default.WebSocket;
var HttpClient = _utils2.default.HttpClient;
function createClient() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var middlewares = [APICall(new HttpClient(options.serverURL || 'http://api.mindself.com', options))];
  if (options.enableWebSocket) {
    middlewares.push(WebSocket(options.websocketURL));
  }
  var store = (0, _redux.createStore)((0, _redux.combineReducers)(_reducers2.default), _redux.applyMiddleware.apply(undefined, middlewares));
  return {
    user: (0, _redux.bindActionCreators)(_actions2.default.UserActions, store.dispatch),
    content: (0, _redux.bindActionCreators)(_actions2.default.ContentActions, store.dispatch),
    comment: (0, _redux.bindActionCreators)(_actions2.default.CommentActions, store.dispatch),
    dir: (0, _redux.bindActionCreators)(_actions2.default.DirActions, store.dispatch),
    tag: (0, _redux.bindActionCreators)(_actions2.default.TagActions, store.dispatch),
    http: (0, _redux.bindActionCreators)(_actions2.default.HTTPClientActions, store.dispatch),
    ws: (0, _redux.bindActionCreators)(_actions2.default.WebSocketActions, store.dispatch),
    _store: store
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/vanilla.js
// module id = 523
// module chunks = 1